import {SagaIterator} from 'redux-saga';
import {call, putResolve, takeEvery, select} from 'redux-saga/effects';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';

import {setCheckoutStep} from '../../reducers/currentStep/currentStep';
import {saveShippingAddressOnAmazonPayment} from '../../reducers/paymentStep/amazonV2/amazonV2';
import {cleanShippingRegion} from '../../reducers/shippingRegion/shippingRegion';
import {getCurrentStep} from '../../selectors/currentStep/currentStep';
import {saveDataFromDeliveryStepOrSwitchNextStep} from '../deliveryStep/finishDeliveryStepSaga/finishDeliveryStepSaga';

/**
 * Loads shipping address region
 */
export function* loadShippingAddressRegion(): SagaIterator {
    const currentStep = yield select(getCurrentStep);

    // TODO: check this on payment step (old version use review step)
    if (currentStep === STEPS.PAYMENT_STEP) {
        const action = yield call(cleanShippingRegion);
        yield putResolve(action);
    }
}

/**
 * Checkout shipping saga
 */
export function* checkoutShippingSaga(): SagaIterator {
    yield takeEvery(`${setCheckoutStep}`, loadShippingAddressRegion);
    yield takeEvery(
        `${saveShippingAddressOnAmazonPayment}`,
        saveDataFromDeliveryStepOrSwitchNextStep,
    );
}
